import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';

export const getRootFontSize: number = window.parseFloat(
  window.getComputedStyle(window.document.querySelectorAll('html')[0]).fontSize
);

export const appTheme = createTheme({
  palette: {
    primary: {
      main: '#e50000',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fff',
    },
  },
  typography: {
    htmlFontSize: getRootFontSize,
  },
});
